import React from 'react';
import Link from 'next/link';

export const PartneredEvent = ({ partneredEvents }) => {
  // Safety check for partneredEvents
  if (!partneredEvents || !Array.isArray(partneredEvents) || partneredEvents.length === 0) {
    return null;
  }

  return (
    <>
      <p className="text-[#006EB7] font-semibold text-base md:text-xl mb-3">Insight from the experts</p>
      <h2 className="text-[#0C0D1A] font-semibold text-3xl md:text-4xl pb-4">Upcoming partner Events</h2>
      <p className="text-[#373945] font-450 text-base pb-12">
        We collaborate with carefully selected partners to offer you more insight into the later life market and how to best support your clients throughout their lifetime mortgage journey. Register for these events today.
      </p>
      <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
        {partneredEvents.map((webinar, index) => {
        // Safety checks for webinar properties
          if (!webinar || !webinar.event_title) {
            return null;
          }

          return (
            <div
              key={index}
              className="bg-[#FFF] rounded-lg border border-[#F3F4F8] overflow-hidden lg:transform lg:transition lg:duration-500 lg:hover:scale-110"
              style={{ boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)' }}
            >
              <Link
                href={webinar.event_url || '#'}
                className="hidden lg:block absolute inset-0 z-[1]"
                target={'_blank'}
              />


              <div className="relative lg:aspect-auto">
                <img
                  src={webinar.event_image_url || '/img/placeholder.jpg'}
                  alt={webinar.event_image_alt_text || webinar.event_title}
                  className="object-cover w-full h-[13.75rem] p-2 rounded-2xl"
                />
                <div className="absolute inset-0 pt-4 pl-4">
                  <p className="rounded-xl text-sm font-medium text-[#F3F4F8] bg-[rgba(12,13,26,0.65)] backdrop-blur-sm inline-flex py-1 px-2 items-center justify-center">
                    {webinar.event_host_name || 'Partner Event'}
                  </p>
                </div>
              </div>

              <div className="pt-4 pb-8 pl-6 pr-6">
                <Link href={webinar.event_url || '#'} className="cursor-pointer">
                  <h3 className="text-2xl text-[#373945] font-medium mb-4">{webinar.event_title}</h3>
                </Link>
                <p className="text-base text-[#006EB7] text-450 mb-4">{webinar.event_subtitle || ''}</p>
                <div
                  dangerouslySetInnerHTML={{ __html: webinar.event_content }}
                  className="text-base text-[#5B5D6B] text-450"
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
